import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import BarNewEditForm from '../bar-new-edit-form';

export default function BarCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new bar item"
        links={[
          {
            name: 'Bar Items',
            href: paths.dashboard.bar.root(),
          },
          { name: 'Create a new bar item' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <BarNewEditForm />
    </Container>
  );
}
